import script from "./ai-meeting-followup.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-meeting-followup.vue?vue&type=script&setup=true&lang=js"

import "./ai-meeting-followup.vue?vue&type=style&index=0&id=129bb4e3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-129bb4e3"]])

export default __exports__